import { HttpErrorResponse } from '@angular/common/http';

/**
 * Backend domain error code `IdentityUsersErrorMap.AuthTokenInvalid` (-6161): the Hanko session JWT is structurally
 * invalid, its signature does not match or its claims are unexpected.
 *
 * The only domain code the AML desk acts on, because it decides the retry strategy: refreshing the platform token
 * cannot fix it (the Kerberos interceptor skips the refresh), and after a failed token exchange the login flow
 * restarts the Hanko flow instead of retrying the exchange. Codes must never be used just to pick a text — the
 * backend sends a localized message for that.
 */
export const AuthTokenInvalidErrorCode = -6161;

/**
 * Checks whether an error is the backend's {@link AuthTokenInvalidErrorCode} response.
 *
 * @param {unknown} error - The error to check.
 * @returns {boolean} `true` for an HTTP error response carrying the code.
 */
export function isAuthTokenInvalidError(error: unknown): boolean {
  return (
    error instanceof HttpErrorResponse && (error.error as { code?: unknown } | null)?.code === AuthTokenInvalidErrorCode
  );
}
